export default {
  getView: state => state.view,
  getLoadingStatus: state => state.loading,
  getLoginStatus: state => state.loggedIn,
  getAuthenticationErrorMsg: state => state.authenticationErrorMsg,
  getAuthenticationErrorCode: state => state.authenticationErrorCode,
  getSuccessMsg: state => state.successMsg,
  getFacebookID: state => state.facebookID
}
